































import { computed, defineComponent } from '@nuxtjs/composition-api'
import NewButton from '@/components/Inputs/new-design/NewButton.vue'

export default defineComponent({
  name: 'BlockTopMessage',
  components: { NewButton },
  props: {
    icon: {
      type: String,
      default: '',
    },
    svgIcon: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
    buttonUrl: {
      type: String,
      default: '',
    },
    textColor: {
      type: String,
      default: '',
    },
    iconColor: {
      type: String,
      default: '',
    },
    background: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const styles = computed(() => ({
      '--top-message-text-color': props.textColor,
      '--top-message-icon-color': props.iconColor,
      '--top-message-background': props.background,
    }))
    const buttonProps = computed(() => {
      if (props.buttonUrl) {
        return {
          url: props.buttonUrl,
          as: 'a',
        }
      }
      return null
    })
    return { styles, buttonProps }
  },
})
